<template>
  <div class="section">
    <div class="header">
      <span>成本总览</span>
    </div>
    <div class="main">
      <div class="left">
        <div class="item">
          <img class="icon" src="@/assets/img/operate/xmys.png" />
          <div class="content">
            <span class="label">项目成本（万元）</span>
            <div class="value">
              <span class="val">{{ formatNumber(details.actualCostAmount) }}</span>
            </div>
            <span class="label">较计划/评估</span>
            <div class="value">
              <span class="val">{{ Math.abs(formatNumber(details.actualToPlanCostAmount)) }}</span>
              <img v-if="details.actualToPlanCostAmount > 0" src="@/assets/img/operate/up.png" />
              <img v-if="details.actualToPlanCostAmount < 0" src="@/assets/img/operate/down.png" />
            </div>
          </div>
        </div>
        <div class="item2">
          <div class="line1">
            <img class="icon" src="@/assets/img/operate/tb.png" />
            <span class="label">项目成本分布</span>
          </div>
          <div class="chart-content" id="chart2"></div>
        </div>
      </div>
      <div class="right">
        <div class="chart-item">
          <div class="chart-header">
            <span class="title">实际与计划/评估成本对比分析</span>
          </div>
          <div class="chart-content" id="chart3"></div>
        </div>
        <div class="chart-item">
          <div class="chart-header">
            <span class="title">成本超支项目排行</span>
            <el-select v-model="chart4Value" @change="chart4Change">
              <el-option label="按超支额" value="1"></el-option>
              <el-option label="按超支率" value="2"></el-option>
            </el-select>
          </div>
          <div class="chart-content" id="chart4"></div>
        </div>
        <div class="chart-item">
          <div class="chart-header">
            <span class="title">成本节约项目排行</span>
            <el-select v-model="chart5Value" @change="chart5Change">
              <el-option label="按节约额" value="1"></el-option>
              <el-option label="按节约率" value="2"></el-option>
            </el-select>
          </div>
          <div class="chart-content" id="chart5"></div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="dialogVisible1" width="800px" title="实际与计划/评估成本对比">
      <el-form inline>
        <el-form-item>
          <el-select v-model="searchForm.costType">
            <el-option :label="value" :value="key" v-for="[key, value] of costTypeMap" :key="key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadCostTypeData">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData1">
        <el-table-column prop="projectName" label="项目名称" />
        <el-table-column prop="actualCostAmount" :label="`实际${costTypeName}（元）`" />
        <el-table-column prop="planCostAmount" :label="`计划${costTypeName}（元）`" />
        <el-table-column prop="actualToPlanCostAmount" label="偏差额（元）" />
      </el-table>
      <el-divider></el-divider>
      <el-table :data="tableData2">
        <el-table-column prop="ym" label="月份" />
        <el-table-column prop="actualCostAmount" :label="`实际${costTypeName}（元）`" />
        <el-table-column prop="planCostAmount" :label="`计划${costTypeName}（元）`" />
        <el-table-column prop="actualToPlanCostAmount" label="偏差额（元）" />
      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible2" width="800px" :title="`成本${isCz ? '超支' : '节约'}项目`">
      <el-form inline>
        <el-form-item>
          {{ currentProjectName }}
        </el-form-item>
      </el-form>
      <el-table :data="tableData3">
        <el-table-column prop="ym" label="月份" />
        <el-table-column prop="" label="人力成本（元）">
          <el-table-column prop="actualPersonCostAmount" label="实际"></el-table-column>
          <el-table-column prop="planPersonCostAmount" label="计划"></el-table-column>
          <el-table-column prop="actualToPlanPersonCostAmount" label="偏差"></el-table-column>
        </el-table-column>
        <el-table-column prop="" label="机械成本（元）">
          <el-table-column prop="actualMachineCostAmount" label="实际"></el-table-column>
          <el-table-column prop="planMachineCostAmount" label="计划"></el-table-column>
          <el-table-column prop="actualToPlanMachineCostAmount" label="偏差"></el-table-column>
        </el-table-column>
        <el-table-column prop="" label="材料成本（元）">
          <el-table-column prop="actualMaterialCostAmount" label="实际"></el-table-column>
          <el-table-column prop="planMaterialCostAmount" label="计划"></el-table-column>
          <el-table-column prop="actualToPlanMaterialCostAmount" label="偏差"></el-table-column>
        </el-table-column>
        <el-table-column prop="" label="间接费（元）">
          <el-table-column prop="actualIndirectAmount" label="实际"></el-table-column>
          <el-table-column prop="planIndirectAmount" label="计划"></el-table-column>
          <el-table-column prop="actualToPlanIndirectCostAmount" label="偏差"></el-table-column>
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
import chartMixin from '@/mixins/mixin'
import { costType } from '@/utils/dict'
export default {
  name: 'Overview2',
  mixins: [chartMixin],
  data() {
    return {
      tableKey1: '',
      tableKey2: '',
      costTypeName: '',
      costTypeMap: costType,
      isCz: true,
      dialogVisible1: false,
      tableData1: [],
      tableData2: [],
      tableData3: [],
      currentProjectName: '',
      dialogVisible2: false,
      dialogVisible3: false,
      chart4Value: '1',
      chart5Value: '1',
      searchForm: {
        startTime: '', // 开始日期
        endTime: '', // 结束日期
        costType: '1'
      },
      details: {
        actualCostAmount: '', // 实际成本金额
        actualToPlanCostAmount: '', // 实际较计划成本差值金额
        upAmountProjectNameList: [], // 超支-按金额-项目名称列表
        upAmountPlanList: [], // 超支-按金额-计划金额列表
        upAmountActualList: [], // 超支-按金额-实际金额列表
        upPerProjectNameList: [], // 超支-按率-项目名称列表
        upPerActualList: [], // 超支-按率-率列表
        downAmountProjectNameList: [], // 节约-按金额-项目名称列表
        actualCostTypePerList: [], // 实际成本分类占比数组(顺序：人、机、材、间)
        downAmountPlanList: [], // 节约-按金额-计划金额列表
        actualCostTypeAmountList: [], // 实际成本分类金额数组(顺序：人、机、材、间)
        downAmountActualList: [], // 节约-按金额-实际金额列表
        planCostTypeAmountList: [], // 计划成本分类金额数组(顺序：人、机、材、间)
        downPerProjectNameList: [], // 节约-按率-项目名称列表
        downPerActualList: [] // 节约-按率-率列表
      }
    }
  },
  created() {
    this.$event.$on('yearMonthChange', this.loadData)
  },
  beforeDestroy() {
    this.$event.$off('yearMonthChange')
  },
  computed: {
    projectList() {
      return this.$store.state.projectList
    }
  },
  watch: {
  },
  methods: {
    formatNumber(num) {
      // 检查输入是否为数字
      if (!num) {
        return '--'
      }
      // 除以 10000 并保留三位小数
      const result = (num / 10000).toFixed(3);
      // 返回结果（注意：toFixed 返回的是字符串，如果需要数字可以转换）
      return parseFloat(result);
    },
    loadData(searchForm) {
      this.searchForm = searchForm
      this.$axios.get(this.$apis.operate.selectCost, searchForm).then(res => {
        this.details = res || {}
        this.initChart2()
        this.initChart3()
        this.initChart4()
        this.initChart5()
      })
    },
    initChart2() {
      const chart = this.$getChartInstance('#chart2')
      if (!chart) return;
      const option = {
        tooltip: {
          trigger: 'item',
          formatter: (params) => {
            let tooltipStr = params.marker + ' ' + params.name + ' ' + `<span style="float:right;margin-left:20px;font-size:14px;color:#666;font-weight:900">${params.value}元</span>`
            return tooltipStr
          }
        },
        legend: {
          show: false
        },
        color: ['#289DF5', '#1AD1B0', '#40557D', '#FFD400'],
        series: [
          {
            type: 'pie',
            radius: ['45%', '70%'],
            avoidLabelOverlap: true,
            itemStyle: {
              borderColor: '#fff',
              borderWidth: 5
            },
            label: {
              show: true
            },
            labelLine: {
              show: true
            },
            data: [
              { value: this.details.actualCostTypeAmountList[0], name: '人力成本' },
              { value: this.details.actualCostTypeAmountList[1], name: '机械成本' },
              { value: this.details.actualCostTypeAmountList[2], name: '材料成本' },
              { value: this.details.actualCostTypeAmountList[3], name: '间接费' }
            ]
          }
        ]
      };
      chart.clear()
      chart.setOption(option)
    },
    initChart3() {
      const chart = this.$getChartInstance('#chart3')
      if (!chart) return;
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            let tooltipStr = params[0].name + '<br>';
            for (let i = 0; i < params.length; i++) {
              tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
            }
            return tooltipStr;
          }
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 50,
          containLabel: true
        },
        yAxis: {
          show: false
        },
        xAxis: {
          type: 'category',
          data: ['人力成本', '机械成本', '材料成本', '间接费'],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            fontSize: 16,
            color: '#7F8FA4'
          }
        },
        series: [
          {
            name: '计划',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: '#346EB1',
            },
            data: this.details.planCostTypeAmountList
          },
          {
            name: '实际',
            type: 'bar',
            barGap: '5%',
            barWidth: 22,
            itemStyle: {
              borderRadius: [50, 50, 0, 0],
              color: '#1AD1B0',
            },
            data: this.details.actualCostTypeAmountList
          }
        ]
      }
      chart.clear()
      chart.setOption(option)
      chart.getZr().off('click')
      chart.getZr().on('click', (params) => {
        console.log('点击的数据项:', params)
        const pointInPixel = [params.offsetX, params.offsetY];
        if (chart.containPixel('grid', pointInPixel)) {
          const index = chart.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0]
          this.searchForm.costType = String(index + 1)
          this.costTypeName = this.costTypeMap.get(this.searchForm.costType)
          this.loadCostTypeData()
          this.dialogVisible1 = true
        }
      })
    },
    initChart4() {
      const chart = this.$getChartInstance('#chart4')
      if (!chart) return;
      let series = []
      let yAxisData = []
      if (this.chart4Value === '1') {
        yAxisData = this.details.upAmountProjectNameList
        series.push({
          name: '计划',
          type: 'bar',
          barGap: '5%',
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 50, 50, 0],
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 1, color: '#FF6D6A' }, // 起始颜色
              { offset: 0, color: '#FF341B' } // 结束颜色
            ]),
          },
          data: this.details.upAmountPlanList
        }, {
          name: '实际',
          type: 'bar',
          barGap: '5%',
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 50, 50, 0],
            color: '#346EB1',
          },
          data: this.details.upAmountActualList
        })
      } else {
        yAxisData = this.details.upPerProjectNameList
        series.push({
          name: '超支率',
          type: 'bar',
          barGap: '5%',
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 50, 50, 0],
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 1, color: '#FF6D6A' }, // 起始颜色
              { offset: 0, color: '#FF341B' } // 结束颜色
            ]),
          },
          data: this.details.upPerActualList
        })
      }
      console.log('yAxisData', yAxisData)
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            if (this.chart4Value === '2') {
              let tooltipStr = params[0].name + '<br>';
              for (let i = 0; i < params.length; i++) {
                // 显示系列名称、图例颜色和数据信息
                tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '%<br>';
              }
              return tooltipStr;
            } else {
              let tooltipStr = params[0].name + '<br>';
              for (let i = 0; i < params.length; i++) {
                // 显示系列名称、图例颜色和数据信息
                tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
              }
              return tooltipStr;
            }
          }
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 50,
          containLabel: true
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            fontSize: 16,
            color: '#7F8FA4',
            formatter: function (value, index) {
              return value.length > 5 ? value.substring(0, 5) + '...' : value;
            }
          },
          data: yAxisData
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        series: series
      }
      chart.clear()
      chart.setOption(option)
      chart.getZr().off('click')
      chart.getZr().on('click', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (chart.containPixel('grid', pointInPixel)) {
          const index = chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[1]
          const projectName = yAxisData[index]
          this.currentProjectName = projectName
          this.isCz = true
          this.loadSelectProjectCostTypeVs(projectName)
          this.dialogVisible2 = true
        }
      })
    },
    initChart5() {
      const chart = this.$getChartInstance('#chart5')
      if (!chart) return;
      let series = []
      let yAxisData = []
      if (this.chart5Value === '1') {
        yAxisData = this.details.downAmountProjectNameList
        series.push({
          name: '计划',
          type: 'bar',
          barGap: '5%',
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 50, 50, 0],
            color: '#2297F0',
          },
          data: this.details.downAmountPlanList
        }, {
          name: '实际',
          type: 'bar',
          barGap: '5%',
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 50, 50, 0],
            color: '#294960',
          },
          data: this.details.downAmountActualList
        })
      } else {
        yAxisData = this.details.downPerProjectNameList
        series.push({
          name: '节约率',
          type: 'bar',
          barGap: '5%',
          barWidth: 22,
          itemStyle: {
            borderRadius: [0, 50, 50, 0],
            color: '#2297F0',
          },
          data: this.details.downPerActualList
        })
      }
      const option = {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params) => {
            if (this.chart5Value === '2') {
              let tooltipStr = params[0].name + '<br>';
              for (let i = 0; i < params.length; i++) {
                // 显示系列名称、图例颜色和数据信息
                tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '%<br>';
              }
              return tooltipStr;
            } else {
              let tooltipStr = params[0].name + '<br>';
              for (let i = 0; i < params.length; i++) {
                // 显示系列名称、图例颜色和数据信息
                tooltipStr += params[i].marker + ' ' + params[i].seriesName + ' ' + params[i].value + '元<br>';
              }
              return tooltipStr;
            }
          }
        },
        grid: {
          top: 0,
          left: 0,
          right: 0,
          bottom: 50,
          containLabel: true
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            fontSize: 16,
            color: '#7F8FA4',
            formatter: function (value, index) {
              return value.length > 5 ? value.substring(0, 5) + '...' : value;
            }
          },
          data: yAxisData
        },
        xAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            show: false
          }
        },
        series: series
      }
      chart.clear()
      chart.setOption(option)
      chart.getZr().off('click')
      chart.getZr().on('click', (params) => {
        const pointInPixel = [params.offsetX, params.offsetY];
        if (chart.containPixel('grid', pointInPixel)) {
          const index = chart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[1]
          const projectName = yAxisData[index]
          this.currentProjectName = projectName
          this.isCz = false
          this.loadSelectProjectCostTypeVs(projectName)
          this.dialogVisible2 = true
        }
      })
    },
    chart4Change(val) {
      console.log('val', val)
      this.initChart4()
    },
    chart5Change() {
      this.initChart5()
    },
    loadCostTypeData() {
      this.costTypeName = this.costTypeMap.get(this.searchForm.costType)
      this.$axios.get(this.$apis.operate.selectCostTypeMonthVs, this.searchForm).then(res => {
        this.tableData1 = res || []
      })
      this.$axios.get(this.$apis.operate.selectCostTypeProjectVs, this.searchForm).then(res => {
        this.tableData2 = res || []
      })
    },
    loadSelectProjectCostTypeVs(projectName) {
      const item = this.projectList.find(item => item.projectName === projectName)
      this.$axios.get(this.$apis.operate.selectProjectCostTypeVs, {
        startTime: this.searchForm.startTime,
        endTime: this.searchForm.endTime,
        projectId: item.projectId
      }).then(res => {
        this.tableData3 = res || []
      })
    }
  }
}
</script>

<style scoped lang="scss">
.section {
  height: 570px;
  background: #FFFFFF;
  border-radius: 2px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;

  &.total {
    height: 392px;
    margin-top: 50px;
  }

  .header {
    height: 60px;
    border-bottom: 1px solid #E8E8E8;
    display: flex;
    align-items: center;
    padding: 0 24px;

    span {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 16px;
      color: #333333;
      line-height: 24px;
      text-align: left;
      font-style: normal;
    }
  }

  .main {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 0 60px;

    .left {
      display: flex;
      flex-direction: column;

      .item {
        display: flex;

        &:nth-child(n + 2) {
          margin-top: 30px;
        }

        .icon {
          width: 24px;
          height: 24px;
          margin-right: 16px;
        }

        .content {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }

          .value {
            display: flex;
            align-items: flex-end;
            align-items: center;
            margin-top: 16px;
            margin-bottom: 16px;

            span {
              &.yuan {
                font-size: 20px;
                margin-right: 10px;
                line-height: 32px;
              }

              &.val {
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                font-size: 24px;
                color: #354052;
                line-height: 32px;
                text-align: left;
                font-style: normal;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }

          .desc {
            display: flex;
            align-items: center;
            margin-top: 20px;

            span {
              &:nth-child(1) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #7F8FA4;
                line-height: 24px;
                text-align: left;
                font-style: normal;
              }

              &:nth-child(2) {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 16px;
                color: #354052;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                margin-left: 10px;
              }
            }

            img {
              width: 15px;
              height: 18px;
              margin-left: 10px;
            }
          }
        }
      }

      .item2 {
        display: flex;
        flex-direction: column;
        height: 250px;

        .line1 {
          display: flex;
          align-items: center;

          img {
            margin-right: 16px;
          }

          .label {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }

        .chart-content {
          width: 250px;
          height: 250px;
          margin-top: 10px;
        }
      }
    }

    .right {
      flex: 1;
      display: flex;
      align-items: center;
      height: 100%;
      margin-left: 90px;

      .chart-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
        padding-top: 49px;

        &:nth-child(n + 2) {
          margin-left: 60px;
        }

        .chart-header {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .title {
            font-family: PingFangSC, PingFang SC;
            font-weight: 600;
            font-size: 16px;
            color: #7F8FA4;
            line-height: 24px;
            text-align: left;
            font-style: normal;
          }
        }

        .chart-content {
          flex: 1;
          padding-top: 40px;
        }
      }
    }
  }
}
</style>
